import { Input, Select, TimePicker } from 'antd';
import { FC, ReactNode } from 'react';
import dayjs from 'dayjs';

/* -------------------------------------------------------------------------------- *\
|                               Infos
\* -------------------------------------------------------------------------------- */
export const Infos: FC<{ children?: ReactNode, label: string, value: string | number | undefined }> = ({ label, value }) =>
{
    return (
        <div className="race__labelvalue">
            <div className="race__labelvalue__label">{label}</div>
            <div className="race__labelvalue__value">{value ? value : ""}</div>
        </div>
    );
}
/* -------------------------------------------------------------------------------- *\
|                               EditInfos
\* -------------------------------------------------------------------------------- */
export const EditInfos: FC<{ children?: ReactNode, type: string, label: string, value: string | number | undefined, options?: { value: string, label: string }[], onChange?: (value: string | number | FileList) => void }> = ({ type, label, value, options, onChange }) =>
{
    const isstring: boolean = type === "string";
    const issmall: boolean = type === "small";
    const isnumber: boolean = type === "number";
    const istime: boolean = type === "time";
    const isfile: boolean = type === "file";
    const isselect: boolean = type === "select";

    return (
        <div className="race__editvalue">
            <div className="race__editvalue__label">{label}</div>
            {
                (isstring || issmall) &&
                    <Input className={"race__editvalue__value" + (issmall ? " race__editvalue__value__small" : "")} defaultValue={value ? value : ""} onChange={(e) => onChange && onChange(e.target.value)}/>
            }
            {
                isnumber &&
                    <Input className="race__editvalue__value race__editvalue__value__number" type="number" defaultValue={value ? value : ""} onChange={(e) => onChange && onChange(Number(e.target.value))}/>
            }
            {
                istime &&
                    <TimePicker needConfirm={false} showNow={false} format="HH:mm" defaultValue={dayjs(value, 'HH:mm')} onChange={(e) => onChange && onChange(e.format("HH:mm"))}/>
            }
            {
                isfile &&
                    <Input className="race__editvalue__value" type="file" onChange={(e) => onChange && e.target.files && onChange(e.target.files)}/>
            }
            {
                isselect &&
                    <Select className="race__editvalue__value" defaultValue={value ? String(value) : undefined} options={options} onChange={(v) => onChange && onChange(v)}/>
            }

        </div>
    );
}
